import _ from 'lodash';
import { getProductsByNumberForSeasonAndNOS, getProductsByNumber } from './products';

import { getCurrentOrder } from './orders';
import { getUserId } from './login';
import { getUserById } from './users';

export const getTischOffensives = (context) =>
  _.filter(_.get(context, 'entities.tischOffensives'), (t) =>
    !(t.id === undefined || t.description === '')).sort((a, b) => {
      const f = 'description';
      if (a[f] < b[f]) { return -1; }
      if (a[f] > b[f]) { return 1; }
      return 0;
    });

export const getTischOffensivesForCurrentUser = (context) => {
  const userId = getUserId(context);
  if (_.isNil(userId)) {
    return null;
  }

  const user = getUserById(context, userId);
  if (_.isNil(user)) {
    return null;
  }

  const allSalesPackages = getTischOffensives(context);

  const defaultPackages = _.filter(allSalesPackages, (t) => {
    const hasId = (t.id || '').length > 0;
    const sp_country = (t.country_region_code || '').toLowerCase();
    const u_country = user.CountryCode;
    return hasId && sp_country === '' && u_country !== 'NB';
  });

  const countryPackages = _.filter(allSalesPackages, (t) => {
    const sp_country = (t.country_region_code || '').toLowerCase();

    if (sp_country === '') {
      return false;
    }

    const user_country = (user.CountryCode || '').toLowerCase();

    const hasId = (t.id || '').length > 0;
    const hasDescription = (t.description || '').length > 0;
    const hasSameCountry = sp_country === user_country;

    return hasId && hasDescription && hasSameCountry;
  });

  return [].concat(countryPackages, defaultPackages);
};

export const getTischOffensivesForId = ({ context, id }) => _.find(getTischOffensives(context), (t) => t.id === id);

export const getTischOffensiveColors = ({context, id}) => {
  // previously we cared about the products in the season. instead, just look at
  // whats in the tischoffensive
  // let productsByNumber = null;
  // if (season) {
  //   productsByNumber = getProductsByNumberForSeasonAndNOS(context)(season);
  // } else {
  //   productsByNumber = getProductsByNumber(context);
  // }

  const tischOffensive = getTischOffensivesForId({ context, id });
  const tischOffensiveItems = _.get(tischOffensive, 'items');
  let productColours = {};
  tischOffensiveItems.forEach((p) => {
    const item_no = p.item_no;
    if (!productColours[item_no]) {
      productColours[item_no] = [];
    }
    productColours[item_no].push(p.colour);
  });

  return productColours;
}

export const getProductsForTischOffensiveId = ({
  context,
  tischOffensiveId,
}) => {

  const currentOrder = getCurrentOrder(context);
  const season = currentOrder ? currentOrder.doc.season : null;

  let productsByNumber;
  if (season) {
    productsByNumber = getProductsByNumberForSeasonAndNOS(context)(season);
  } else {
    productsByNumber = getProductsByNumber(context);
  }
  if (!productsByNumber) {
    return [];
  }

  const productColours = getTischOffensiveColors({context, season, id: tischOffensiveId});
  let items = [];
  const itemNos = Object.keys(productColours);
  _.each(productsByNumber, (p) => {
    if (itemNos.includes(p.n)) {
      items.push(p);
    }
  });

  return {
    products: items,
    colours: productColours
  };
};
